import {
  isNetworkQuestionsDisabled,
  isNetworkQuestionsEnabledAndLicensed,
  isNetworkQuestionsEnabledButNotLicensed,
} from '@ms/yammer-data/dist/domains/networkQuestions/selectors';

import { useSelector } from '../useSelector';

type UseIsNetworkQuestionsDisabled = () => ReturnType<typeof isNetworkQuestionsDisabled>;
export const useIsNetworkQuestionsDisabled: UseIsNetworkQuestionsDisabled = () =>
  useSelector(isNetworkQuestionsDisabled);

type UseIsNetworkQuestionsEnabledButNotLicensed = () => ReturnType<typeof isNetworkQuestionsEnabledButNotLicensed>;
export const useIsNetworkQuestionsEnabledButNotLicensed: UseIsNetworkQuestionsEnabledButNotLicensed = () =>
  useSelector(isNetworkQuestionsEnabledButNotLicensed);

type UseIsNetworkQuestionsEnabledAndLicensed = () => ReturnType<typeof isNetworkQuestionsEnabledAndLicensed>;
export const useIsNetworkQuestionsEnabledAndLicensed: UseIsNetworkQuestionsEnabledAndLicensed = () =>
  useSelector(isNetworkQuestionsEnabledAndLicensed);
